import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import * as userManager from "../../Services/UserSessionManager";
import { LandingPage } from "../UserLogin/Landing";
import { AppNavBar } from "./AppNavBar";
import { Home } from "./Home";
import { EmployeeTeamsList } from "../EmployeeTeamDetail/EmployeeTeamsList";
import { TeamDetails } from "../TeamDetails/TeamDetail";
import { TeamDetailSimple } from "../TeamDetails/TeamDetailSimple";
import { EmployeeTeamDetailCard } from "../EmployeeTeamDetail/EmployeeTeamDetailCard";
import { FileUpload } from "../FileUpload/FileUpload";
import { EmployeeDataList } from "../EmployeeTeamDetail/EmployeeDataList";
import { EmployeeInformation } from "../EmployeeInformation/EmployeeInfo";
import { AttritionDetails } from "../AttritionReport/AttritionDetails";
import { AccountList } from "../Master/AccountMaster/AccountList";
import { ProcessList } from "../Master/ProcessMaster/ProcessList";
import { SubStateList } from "../Master/SubStateMaster/SubStateList";
import { WeightageList } from "../Master/WeightageMaster/WeightageList";
import { KraApprovalScreen } from "../KRAScreens/KRAApprovalScreen";
import { KRAEntryScreen } from "../KRAScreens/KRAEntryScreen";
import { TeamProductionReport } from "../KRAScreens/TeamProductionReport";
import { PKTUpload } from "../FileUpload/ManagerUploads";
import { PKTReport } from "../KRAScreens/PKTReport";
import { ManagerFeedBackView } from "../KRAScreens/ManagerFeedBackView";
import { FinalKRAReport } from "../KRAScreens/FinalKRAReport";
import { QualityModule } from "../KRAScreens/QualityModule";
import { QualityUpload } from "../FileUpload/QualityUpload";
import { ProcessBuffer } from "../TeamDetails/ProcessBuffer";
import { ManagerProcess } from "../TeamDetails/ManagerBuffer";
import { ChangeHRRole } from "../KRAScreens/ChangeHRRole";
import { ChangeManagerRole } from "../KRAScreens/ChangeManagerRole";
import { ChangeAdminRole } from "../KRAScreens/ChangeAdminRole";

import { ChangeEmployeeRole } from "../KRAScreens/ChangeEmployeeRole";
import { LocationProcess } from "../TeamDetails/LocationBuffer";
import { ApplicationSearch } from "../ManageApplication/ApplicationSearch";
import { ManageEmployeeApplication } from "../ManageApplication/ManageEmployeeApplication";
import { AttendanceReport } from "../KRAScreens/AttendanceReport";
import { QMTeam } from "../EmployeeTeamDetail/QMTeam";
import { ChangeQMRole } from "../KRAScreens/ChangeQMRole";
import { ChangeTrainerRole } from "../KRAScreens/ChangeTrainerRole";
import { BIManagerRole } from "../KRAScreens/ChangeBIManager";
import { AttritionDetailsBI } from "../AttritionReport/AttritionDetailsBI";
import { ExpectionsOrRejectionsBI } from "../AttritionReport/ExpectionsBI";
import { RejectionsBI } from "../AttritionReport/RejectionsBI";
import { IdeasList } from "../IdeaPortal/IdeasList";

export const AppLayout = () => {
  const [checkRole, setCheckRole] = useState(userManager.GetUserRole());
  return (
    <div>
      <AppNavBar />
      <div className="p-3">
        {/* --------------------------------------------------------------------------------- */}
        {/* ----------------------------------Checking Roles and providing route path---------------------------------- */}
        {checkRole == "H" || checkRole == "A" ? (
          <Routes>
            <Route path="/FileUpload" element={<FileUpload />} />
            <Route path="/AttritionDetails" element={<AttritionDetails />} />
            <Route
              path="/AttritionDetailsBI"
              element={<AttritionDetailsBI />}
            />
          </Routes>
        ) : (
          <Routes>
            <Route path="/FileUpload" element={<Home />} />
            <Route path="/AttritionDetails" element={<Home />} />
            <Route path="/AttritionDetailsBI" element={<Home />} />
          </Routes>
        )}
        {/* {checkRole=='H'||checkRole=='PM'||checkRole=='M'||checkRole=='A'||checkRole=='QM'?  */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Test" element={<LandingPage />} />
          <Route path="/EmployeeDetails" element={<EmployeeTeamsList />} />
          <Route
            path="/ExpectionsOrRejectionsBI"
            element={<ExpectionsOrRejectionsBI />}
          />
          <Route path="/RejectionsBI" element={<RejectionsBI />} />
          <Route path="/TeamDetails" element={<TeamDetails />} />
          <Route path="/ProcessBuffer" element={<ProcessBuffer />} />
          <Route path="/Teams" element={<TeamDetailSimple />} />
          <Route path="/EmployeeCard" element={<EmployeeTeamDetailCard />} />
          <Route path="/EmpoyeeDataList" element={<EmployeeDataList />} />
          <Route path="/EmployeeInfo" element={<EmployeeInformation />} />
          <Route path="/Accounts" element={<AccountList />} />
          <Route path="/ProcessMaster" element={<ProcessList />} />
          <Route path="/Accounts" element={<AccountList />} />
          <Route path="/ProcessMaster" element={<ProcessList />} />
          <Route path="/SubStateMaster" element={<SubStateList />} />
          <Route path="/WeightageMaster" element={<WeightageList />} />
          <Route path="/ApplicationSearch" element={<ApplicationSearch />} />
          <Route path="/KraApproval" element={<KraApprovalScreen />} />
          <Route path="/EntryScreen" element={<KRAEntryScreen />} />
          <Route
            path="/Productivityreport"
            element={<TeamProductionReport />}
          />
          <Route path="/PKTReport" element={<PKTReport />} />
          <Route path="/PKTUpload" element={<PKTUpload />} />
          <Route path="/QualityUpload" element={<QualityUpload />} />
          <Route path="/ManagerProcess" element={<ManagerProcess />} />
          <Route path="/HRRole" element={<ChangeHRRole />} />
          <Route path="/ManagerRole" element={<ChangeManagerRole />} />
          <Route path="/AdminRole" element={<ChangeAdminRole />} />
          <Route path="/TrainerRole" element={<ChangeTrainerRole />} />
          <Route path="/BIManagerRole" element={<BIManagerRole />} />
          <Route path="/EmployeeRole" element={<ChangeEmployeeRole />} />
          <Route path="/KRAReport" element={<FinalKRAReport />} />
          <Route
            path="/EmployeeSearch"
            element={<ManageEmployeeApplication />}
          />
          <Route path="/AttendanceReport" element={<AttendanceReport />} />
          <Route path="/QMTeamReport" element={<QMTeam />} />
          <Route path="/QualityRole" element={<ChangeQMRole />} />
          <Route path="/LocationProcess" element={<LocationProcess />} />
          <Route path="/ManagerFeedBack" element={<ManagerFeedBackView />} />
          <Route path="/QualityReport" element={<QualityModule />} />
          <Route path="/IdeasList" element={<IdeasList />} />
        </Routes>
        {/* :<Routes>

                <Route path='/' element={<Home/>}/>
                <Route path="/ApplicationSearch" element={<ApplicationSearch />} />
                <Route path="/EmployeeSearch" element={<ManageEmployeeApplication/>} />
                <Route path='/Test' element={<Home/>}/>
                <Route path="/EmployeeDetails" element={<Home/>}/>
                <Route path="/TeamDetails" element={<Home/>}/>
                <Route path="/Teams" element={<Home/>}/>
                <Route path="/EmployeeCard" element={<Home/>}/>
                <Route path="/EmpoyeeDataList" element={<Home/>}/>
                <Route path="/EmployeeInfo" element={<Home/>}/>
                <Route path="/KraApproval" element={<KraApprovalScreen />} />
                <Route path="/EntryScreen" element={<KRAEntryScreen/>} />
                <Route path="/KRAReport" element={<FinalKRAReport/>} />
                <Route path="/HRRole" element={<ChangeHRRole/>} />
                <Route path="/ManagerRole" element={<ChangeManagerRole/>}/>
                <Route path="/QualityRole" element={<ChangeQMRole/>}/>
                <Route path="/TrainerRole" element={<ChangeTrainerRole/>} />
                <Route path="/EmployeeRole" element={<ChangeEmployeeRole/>}/>
                <Route path="/AdminRole" element={<ChangeAdminRole/>} />
            </Routes>}  */}
      </div>
    </div>
  );
};
